// extracted by mini-css-extract-plugin
var _1 = "P8NQ3QfH0oR6UwaICKgQ";
export { _1 as "masonpadding" }
